import {Component, Input, OnInit} from '@angular/core';
import {ApiAddress} from "../../../common/model/cchsApiContractData.model";

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss']
})
export class AddressComponent implements OnInit {

  @Input() apiAddress: ApiAddress = {};

  constructor() { }

  ngOnInit() {
  }

}
